<template>
  <div class="content2 setmargin">
    <vue-headful
    title="Dashboard | Logo Files"
    description="Dashboard | Logo Files"
/>

<div v-if="loading" style="margin: 0 auto; padding: 70px 0px 0px !important;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>

<div v-if="!loading" class="sc-kAdXeD jwoEpG" style="padding: 40px 0px 0px !important;">
  <div class="sc-bvTASY jPMoWD">
    <div class="mb-4 sinpaddingmobile" style="padding-top: 60px;">
      <h2 class="f342fdw" style="color: #4a5073;">Your Logo Files</h2>
      <p>Access your logo in the most common formats and sizes. Easily download all your files and view the details of the colors and fonts used in your logo.</p>
    </div> 
  </div>
  <div class="sc-bvTASY jPMoWD">

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">High Resolution Logo</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.high_res_color_logo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">High Resolution Color Logo</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.high_res_color_logo_svgcode, 'High-Resolution-Color-Logo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.high_res_color_logo_svgcode, 'High-Resolution-Color-Logo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.high_res_black_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: #ffffff;'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">High Resolution Logo Black on White Background</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.high_res_black_white_svgcode, 'High-Resolution-Logo-Black-on-White-Background')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.high_res_black_white_svgcode, 'High-Resolution-Logo-Black-on-White-Background')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.high_res_white_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: #000000;'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">High Resolution Logo White on Black Background</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.high_res_white_black_svgcode, 'High-Resolution-Logo-White-on-Black-Background')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.high_res_white_black_svgcode, 'High-Resolution-Logo-White-on-Black-Background')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.high_res_color_logo_transparent_bg_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">High Resolution Color Logo on Transparent Background</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.high_res_color_logo_transparent_bg_svgcode, 'High-Resolution-Color-Logo-on-Transparent-Background')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.high_res_color_logo_transparent_bg_svgcode, 'High-Resolution-Color-Logo-on-Transparent-Background')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.high_res_black_transparent_bg_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">High Resolution Logo Black on Transparent Background</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.high_res_black_transparent_bg_svgcode, 'High-Resolution-Logo-Black-on-Transparent-Background')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.high_res_black_transparent_bg_svgcode, 'High-Resolution-Logo-Black-on-Transparent-Background')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.high_res_white_transparent_bg_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">High Resolution Logo White on Transparent Background</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.high_res_white_transparent_bg_svgcode, 'High-Resolution-Logo-White-on-Transparent-Background')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.high_res_white_transparent_bg_svgcode, 'High-Resolution-Logo-White-on-Transparent-Background')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Essentials</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.icononly_original_color_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Icon Only - Color</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.icononly_original_color_svgcode, 'Icon-Only-Color')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.icononly_original_color_svgcode, 'Icon-Only-Color')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.icononly_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Icon Only - Black</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.icononly_black_svgcode, 'Icon-Only-Black')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.icononly_black_svgcode, 'Icon-Only-Black')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.icononly_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Icon Only - White</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.icononly_white_svgcode, 'Icon-Only-White')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.icononly_white_svgcode, 'Icon-Only-White')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.only_business_slogan_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Without Icon - Color</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.only_business_slogan_svgcode, 'Without-Icon-Color')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.only_business_slogan_svgcode, 'Without-Icon-Color')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.only_business_slogan_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Without Icon - Black</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.only_business_slogan_black_svgcode, 'Without-Icon-Black')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.only_business_slogan_black_svgcode, 'Without-Icon-Black')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.only_business_slogan_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Without Icon - White</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.only_business_slogan_white_svgcode, 'Without-Icon-White')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.only_business_slogan_white_svgcode, 'Without-Icon-White')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Favicon</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.favicon_original_color_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px; scale: 0.3;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Website Favicon - Color</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.favicon_original_color_svgcode, 'Website-Favicon-Color')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.favicon_original_color_svgcode, 'Website-Favicon-Color')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.favicon_black_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px; scale: 0.3;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Website Favicon - Black</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.favicon_black_svgcode, 'Website-Favicon-Black')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.favicon_black_svgcode, 'Website-Favicon-Black')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div style="background-position: 0px 0px, 10px 10px;background-size: 20px 20px;background-image: linear-gradient(45deg, rgb(238, 238, 238) 25%, transparent 25%, transparent 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%), linear-gradient(45deg, rgb(238, 238, 238) 25%, rgb(248, 248, 248) 25%, rgb(248, 248, 248) 75%, rgb(238, 238, 238) 75%, rgb(238, 238, 238) 100%);">
            <div class="card-body px-0" :style="'background-image: url('+files.favicon_white_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px; scale: 0.3;'"></div>
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-3">Website Favicon - White</h5>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-logo-files"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.favicon_white_svgcode, 'Website-Favicon-White')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.favicon_white_svgcode, 'Website-Favicon-White')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Color Palette</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="d-block d-lg-flex" style="border: 1px solid rgb(221, 221, 221);">
      <div :style="'background: ' + 
      (logo.background_gradient > 0 
        ? this.gradients[logo.background_gradient].css 
        : logo.background_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;'" class="w-100">{{ logo.background_gradient > 0 ? 'GRADIENT' : logo.background_color }}</div>
      <div v-if="logo.container_num !== '0'" :style="'background: ' + 
      (logo.container_gradient > 0 
        ? this.gradients[logo.container_gradient].css 
        : logo.container_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;'" class="w-100">{{ logo.container_gradient > 0 ? 'GRADIENT' : logo.container_color }}</div>
      <div v-if="logo.layout !== '3'" :style="'background: ' + 
      (logo.icon_gradient > 0 
        ? this.gradients[logo.icon_gradient].css 
        : logo.icon_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;'" class="w-100">{{ logo.icon_gradient > 0 ? 'GRADIENT' : logo.icon_color }}</div>
      <div v-if="logo.business_name_color" :style="'background: ' + 
      (logo.business_name_gradient > 0 
        ? this.gradients[logo.business_name_gradient].css 
        : logo.business_name_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;'" class="w-100">{{ logo.business_name_gradient > 0 ? 'GRADIENT' : logo.business_name_color }}</div>
      <div v-if="logo.slogan" :style="'background: ' + 
      (logo.slogan_gradient > 0 
        ? this.gradients[logo.slogan_gradient].css 
        : logo.slogan_color) + 
      ';font-size: 18px;font-weight: 600;text-align: center;vertical-align: middle;line-height: 102px;color: rgb(255, 255, 255);text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000;'" class="w-100">{{ logo.slogan_gradient > 0 ? 'GRADIENT' : logo.slogan_color }}</div>

    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Typography</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="mb-4 bg-white" style="border: 1px solid rgb(221, 221, 221); border-radius: 0.5rem;">
      <div class="d-block d-lg-flex">
        <div v-if="logo.monogram === 'yes'" class="p-3 w-100">
          <p class="text-gray mb-2">Monogram Font</p>
          <h4 class="mb-3">{{logo.monogram_font_name}}</h4>
          <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" style="color: #ffffff;" data-toggle="modal" data-target="#modal-logo-files"> Download </a>
          <a v-else :href="'https://logo.app/fonts/'+logo.monogram_font_ttf" :download="logo.monogram_font_ttf" class="btn btn-blue w-100" style="color: #ffffff;"> Download </a>
        </div>
        <div v-if="logo.business_name" class="p-3 w-100">
          <p class="text-gray mb-2">Business Name Font</p>
          <h4 class="mb-3">{{logo.business_name_font_name}}</h4>
          <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" style="color: #ffffff;" data-toggle="modal" data-target="#modal-logo-files"> Download </a>
          <a v-else :href="'https://logo.app/fonts/'+logo.business_name_font_ttf" :download="logo.monogram_fobusiness_name_font_ttfnt_ttf" class="btn btn-blue w-100" style="color: #ffffff;"> Download </a>
        </div>
        <div v-if="logo.slogan" class="p-3 w-100">
          <p class="text-gray mb-2">Slogan Font</p>
          <h4 class="mb-3">{{logo.slogan_font_name}}</h4>
          <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" style="color: #ffffff;" data-toggle="modal" data-target="#modal-logo-files"> Download </a>
          <a v-else :href="'https://logo.app/fonts/'+logo.slogan_font_ttf" :download="logo.slogan_font_ttf" class="btn btn-blue w-100" style="color: #ffffff;"> Download </a>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Hidden container for SVG processing -->
<div id="svgContainer-edit" class="offscreen"></div>

</div>
</template>

<style>
/* Off-screen CSS */
.offscreen {
  position: absolute;
  visibility: hidden; /* The element is not visible, but it is still rendered */
  width: 1px;         /* Minimize the element size */
  height: 1px;
  overflow: hidden;   /* Ensure that no part of the element spills over */
  left: 0;            /* Position it at the top-left corner to avoid any layout issues */
  top: 0;
}
</style>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  props:['propsdata'],
  data() {
    return {
      timenow: Date.now(),
      loading: true,
      logo_unique_id: '',
      logo: [],
      gradients: {
        '1':{
          'css':'linear-gradient(rgb(23, 234, 217) 0%, rgb(96, 120, 234) 100%)',
          'svg':'<linearGradient id="gradient-1" x1="49.99999999999999%" y1="0%" x2="50.00000000000001%" y2="100%"><stop offset="0.00" stop-color="#17ead9"></stop><stop offset="1.00" stop-color="#6078eb"></stop></linearGradient>'
        },
        '2':{
          'css':'linear-gradient(to top, #09203f 0%, #537895 100%)',
          'svg':'<linearGradient id="gradient-2" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#09203f" />       <stop offset="100%" stop-color="#537895" />     </linearGradient>'
        },
        '3':{
          'css':'linear-gradient(to right, rgb(182, 244, 146), rgb(51, 139, 147))',
          'svg':'<linearGradient id="gradient-3" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="rgb(182, 244, 146)" />       <stop offset="100%" stop-color="rgb(51, 139, 147)" />     </linearGradient>'
        },
        '4':{
          'css':'radial-gradient( circle farthest-corner at 10% 20%,  rgba(14,174,87,1) 0%, rgba(12,116,117,1) 90% )',
          'svg':'<radialGradient id="gradient-4" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(14, 174, 87, 1)" />       <stop offset="90%" stop-color="rgba(12, 116, 117, 1)" />     </radialGradient>'
        },
        '5':{
          'css':'linear-gradient(90deg, rgb(242, 112, 156) 0%, rgb(255, 148, 114) 100%)',
          'svg':'<linearGradient id="gradient-5" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f2709c"></stop><stop offset="1.00" stop-color="#ff9472"></stop></linearGradient>'
        },
        '6':{
          'css':'linear-gradient(90deg, rgb(240, 11, 81) 0%, rgb(115, 0, 98) 100%)',
          'svg':'<linearGradient id="gradient-6" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f00b51"></stop><stop offset="1.00" stop-color="#730062"></stop></linearGradient>'
        },
        '7':{
          'css':'linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)',
          'svg':'<linearGradient id="gradient-7" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#a18cd1" />       <stop offset="100%" stop-color="#fbc2eb" />     </linearGradient>'
        },
        '8':{
          'css':'linear-gradient(to right, #ad5389, #3c1053)',
          'svg':'<linearGradient id="gradient-8" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="#ad5389" />       <stop offset="100%" stop-color="#3c1053" />     </linearGradient>'
        },
        '9':{
          'css':'radial-gradient( circle 860px at 11.8% 33.5%,  rgba(240,30,92,1) 0%, rgba(244,49,74,1) 30.5%, rgba(249,75,37,1) 56.1%, rgba(250,88,19,1) 75.6%, rgba(253,102,2,1) 100.2% )',
          'svg':'<radialGradient id="gradient-9" cx="11.8%" cy="33.5%" r="860px">       <stop offset="0%" stop-color="rgba(240, 30, 92, 1)" />       <stop offset="30.5%" stop-color="rgba(244, 49, 74, 1)" />       <stop offset="56.1%" stop-color="rgba(249, 75, 37, 1)" />       <stop offset="75.6%" stop-color="rgba(250, 88, 19, 1)" />       <stop offset="100.2%" stop-color="rgba(253, 102, 2, 1)" />     </radialGradient>'
        },
        '10':{
          'css':'radial-gradient( circle farthest-corner at 50.4% 50.5%,  rgba(251,32,86,1) 0%, rgba(135,2,35,1) 90% )',
          'svg':'<radialGradient id="gradient-10" cx="50.4%" cy="50.5%" r="100%" fx="50.4%" fy="50.5%">       <stop offset="0%" stop-color="rgba(251, 32, 86, 1)" />       <stop offset="90%" stop-color="rgba(135, 2, 35, 1)" />     </radialGradient>'
        },
        '11':{
          'css':'radial-gradient(489px at 49.3% 46.6%, rgb(255, 214, 126) 0%, rgb(253, 200, 0) 100.2%)',
          'svg':'<radialGradient id="gradient-11" cx="49.3%" cy="46.6%" r="489px">       <stop offset="0%" stop-color="rgb(255, 214, 126)" />       <stop offset="100.2%" stop-color="rgb(253, 200, 0)" />     </radialGradient>'
        },
        '12':{
          'css':'linear-gradient( 109.6deg,  rgba(255,115,68,1) 11.2%, rgba(244,255,32,1) 100.6% )',
          'svg':'<linearGradient id="gradient-12" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(255, 115, 68, 1)" />       <stop offset="100.6%" stop-color="rgba(244, 255, 32, 1)" />     </linearGradient>'
        },
        '13':{
          'css':'linear-gradient( 90.5deg,  rgba(255,207,139,0.50) 1.1%, rgba(255,207,139,1) 81.3% )',
          'svg':'<linearGradient id="gradient-13" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(90.5, 0.5, 0.5)">       <stop offset="1.1%" stop-color="rgba(255, 207, 139, 0.50)" />       <stop offset="81.3%" stop-color="rgba(255, 207, 139, 1)" />     </linearGradient>'
        },
        '14':{
          'css':'linear-gradient( 109.6deg,  rgba(162,2,63,1) 11.2%, rgba(231,62,68,1) 53.6%, rgba(255,129,79,1) 91.1% )',
          'svg':'<linearGradient id="gradient-14" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(162, 2, 63, 1)" />       <stop offset="53.6%" stop-color="rgba(231, 62, 68, 1)" />       <stop offset="91.1%" stop-color="rgba(255, 129, 79, 1)" />     </linearGradient>'
        },
        '15':{
          'css':'radial-gradient( circle farthest-corner at 10% 20%,  rgba(0,95,104,1) 0%, rgba(15,156,168,1) 90% )',
          'svg':'<radialGradient id="gradient-15" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(0, 95, 104, 1)" />       <stop offset="90%" stop-color="rgba(15, 156, 168, 1)" />     </radialGradient>'
        },
        '16':{
          'css':'linear-gradient( 113.3deg,  rgba(134,209,228,1) -1.8%, rgba(60,80,115,1) 86.4% )',
          'svg':'<linearGradient id="gradient-16" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(113.3, 0.5, 0.5)">       <stop offset="-1.8%" stop-color="rgba(134, 209, 228, 1)" />       <stop offset="86.4%" stop-color="rgba(60, 80, 115, 1)" />     </linearGradient>'
        },
        '17':{
          'css':'linear-gradient( 76.3deg,  rgba(44,62,78,1) 12.6%, rgba(69,103,131,1) 82.8% )',
          'svg':'<linearGradient id="gradient-17" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(76.3, 0.5, 0.5)">       <stop offset="12.6%" stop-color="rgba(44, 62, 78, 1)" />       <stop offset="82.8%" stop-color="rgba(69, 103, 131, 1)" />     </linearGradient>'
        },
        '18':{
          'css':'linear-gradient( 109.6deg,  rgba(20,30,48,1) 11.2%, rgba(36,59,85,1) 91.1% )',
          'svg':'<linearGradient id="gradient-18" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(20, 30, 48, 1)" />       <stop offset="91.1%" stop-color="rgba(36, 59, 85, 1)" />     </linearGradient>'
        },
        '19':{
          'css':'linear-gradient(90deg, #905e25 0%, #f5ec8b 50%, #905e36 100%)',
          'svg':'<linearGradient id="gradient-19"><stop stop-color="#905e25" offset="0"></stop><stop stop-color="#f5ec8b" offset="0.5"></stop><stop stop-color="#905e36" offset="1"></stop></linearGradient>'
        },
        '20':{
          'css':'linear-gradient(90deg, #616162 0%, #e6e7e9 50%, #616162 100%)',
          'svg':'<linearGradient id="gradient-20"><stop stop-color="#616162" offset="0"></stop><stop stop-color="#e6e7e9" offset="0.5"></stop><stop stop-color="#616162" offset="1"></stop></linearGradient>'
        },
        '21':{
          'css':'linear-gradient(to right, #834f3a 0%, #dba174 50%, #834F3A 100%)',
          'svg':'<linearGradient id="gradient-21"><stop stop-color="#834f3a" offset="0"></stop><stop stop-color="#dba174" offset="0.5"></stop><stop stop-color="#834F3A" offset="1"></stop></linearGradient>'
        }
      },
      files: {},
      retry_axios: 1
    };
  },
  methods: {
    downloadSvgFile(svg_code, file_name) {
      // Get the SVG code string from svg_code
      const svgCode = svg_code;

      // Create a Blob from the SVG code
      const blob = new Blob([svgCode], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const downloadLink = document.createElement('a');

      // Set the download attribute with a filename
      downloadLink.download = file_name+'.svg';

      // Set the href attribute to the Blob URL
      downloadLink.href = url;

      // Append the link to the document body (required for Firefox)
      document.body.appendChild(downloadLink);

      // Programmatically click the link to trigger the download
      downloadLink.click();

      // Clean up by removing the link and revoking the Blob URL
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    },
    downloadPngFile(svg_code, file_name) {
      if(file_name !== 'Website-Favicon-Color' && file_name !== 'Website-Favicon-Black' && file_name !== 'Website-Favicon-White'){
        // File name does not contain favicon
        var width = 1000;  // Default size of image set to 1000x1000
        var height = 1000; // Default size of image set to 1000x1000
      }
      else{
        // File name contains favicon
        var width = 128;  // Default size of favicon set to 128x128
        var height = 128; // Default size of favicon set to 128x128
      }

      // Create an image element
      const img = new Image();

      // Create a Blob from the SVG code
      const blob = new Blob([svg_code], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Set the image source to the Blob URL
      img.src = url;

      // Wait for the image to load
      img.onload = () => {
        // Create a canvas element
        const canvas = document.createElement('canvas');

        // Set the canvas dimensions to the desired size
        canvas.width = width;
        canvas.height = height;

        // Draw the image onto the canvas with the specified dimensions
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas to a data URL in PNG format
        const pngUrl = canvas.toDataURL('image/png');

        // Create a temporary link element
        const downloadLink = document.createElement('a');

        // Set the download attribute with a filename
        downloadLink.download = file_name+'.png';

        // Set the href attribute to the PNG data URL
        downloadLink.href = pngUrl;

        // Append the link to the document body (required for Firefox)
        document.body.appendChild(downloadLink);

        // Programmatically click the link to trigger the download
        downloadLink.click();

        // Clean up by removing the link and revoking the Blob URL
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
      };
    },
    setHighResColorLogo(){
      // Get the SVG code string from this.logo.svg
      const svgCode = this.logo.svg;
      // Save SVG code string
      this.files.high_res_color_logo_svgcode = svgCode;
      // Encode the SVG code to Base64
      const base64Svg = btoa(encodeURIComponent(svgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
      }));
      // Create the data URL for the background image
      this.files.high_res_color_logo_base64 = `data:image/svg+xml;base64,${base64Svg}`;
    },
    setHighResBlackAndWhite() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background" and set it to white
      const backgroundRect = svgDocument.querySelector('rect[data-name="background"]');
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', '#FFFFFF');
      }

      // Find the <g> element with data-name="container"
      const container = svgDocument.querySelector('g[data-name="container"]');
      
      let applyDefaultColors = true;

      if (container) {
        // Check the container_num
        const containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        const containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to black
          container.setAttribute('fill', '#000000');

          if(this.logo.which_container === 'only_icon'){
            // Find the <g> elements for icon, and monogram and set them to white
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#FFFFFF');
            });
            // Find the <g> elements for business name and slogan and set them to black
            const elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(element => {
              element.setAttribute('fill', '#000000');
            });
          }
          else{
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to white
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#FFFFFF');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to black if they exist
        const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        elementsToChange.forEach(element => {
          element.setAttribute('fill', '#000000');
        });
      }

      // Serialize the modified SVG back to a string
      const serializer = new XMLSerializer();
      const modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_black_white_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      const base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_black_white_base64 = `data:image/svg+xml;base64,${base64Svg}`;
    },
    setHighResWhiteAndBlack() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background" and set it to black
      const backgroundRect = svgDocument.querySelector('rect[data-name="background"]');
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', '#000000');
      }

      // Find the <g> element with data-name="container"
      const container = svgDocument.querySelector('g[data-name="container"]');
      
      let applyDefaultColors = true;

      if (container) {
        // Check the container_num
        const containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        const containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to white
          container.setAttribute('fill', '#FFFFFF');

          if(this.logo.which_container === 'only_icon'){
            // Find the <g> elements for icon, and monogram and set them to black
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#000000');
            });
            // Find the <g> elements for business name and slogan and set them to white
            const elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(element => {
              element.setAttribute('fill', '#FFFFFF');
            });
          }
          else{
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to black
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#000000');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to white if they exist
        const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        elementsToChange.forEach(element => {
          element.setAttribute('fill', '#FFFFFF');
        });
      }

      // Serialize the modified SVG back to a string
      const serializer = new XMLSerializer();
      const modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_white_black_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      const base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_white_black_base64 = `data:image/svg+xml;base64,${base64Svg}`;
    },
    setHighResColorLogoTransparentBackground() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background"
      const backgroundRect = svgDocument.querySelector('rect[data-name="background"]');

      // Set the fill attribute to 'none' or 'transparent'
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', 'none');
      }

      // Serialize the modified SVG back to a string
      const serializer = new XMLSerializer();
      const modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_color_logo_transparent_bg_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      const base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_transparent_bg
      this.files.high_res_color_logo_transparent_bg_base64 = `data:image/svg+xml;base64,${base64Svg}`;
    },
    setHighResBlackTransparentBackground() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background"
      const backgroundRect = svgDocument.querySelector('rect[data-name="background"]');

      // Set the fill attribute to 'none' or 'transparent'
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', 'none');
      }

      // Find the <g> element with data-name="container"
      const container = svgDocument.querySelector('g[data-name="container"]');
      
      let applyDefaultColors = true;

      if (container) {
        // Check the container_num
        const containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        const containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to black
          container.setAttribute('fill', '#000000');

          if(this.logo.which_container === 'only_icon'){
            // Find the <g> elements for icon, and monogram and set them to white
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#FFFFFF');
            });
            // Find the <g> elements for business name and slogan and set them to black
            const elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(element => {
              element.setAttribute('fill', '#000000');
            });
          }
          else{
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to white
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#FFFFFF');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to black if they exist
        const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        elementsToChange.forEach(element => {
          element.setAttribute('fill', '#000000');
        });
      }

      // Serialize the modified SVG back to a string
      const serializer = new XMLSerializer();
      const modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_black_transparent_bg_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      const base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_black_transparent_bg_base64 = `data:image/svg+xml;base64,${base64Svg}`;
    },
    setHighResWhiteTransparentBackground() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <rect> element with data-name="background"
      const backgroundRect = svgDocument.querySelector('rect[data-name="background"]');

      // Set the fill attribute to 'none' or 'transparent'
      if (backgroundRect) {
        backgroundRect.setAttribute('fill', 'none');
      }

      // Find the <g> element with data-name="container"
      const container = svgDocument.querySelector('g[data-name="container"]');
      
      let applyDefaultColors = true;

      if (container) {
        // Check the container_num
        const containerNumMatch = container.getAttribute('data').match(/container_num:(\d+)/);
        const containerNum = containerNumMatch ? containerNumMatch[1] : null;

        // Containers that have background
        if (containerNum === '2' || containerNum === '3' || containerNum === '6' || containerNum === '8' || containerNum === '10' || containerNum === '12' || containerNum === '13' || containerNum === '15' || containerNum === '17') {
          // Set the container color to white
          container.setAttribute('fill', '#FFFFFF');

          if(this.logo.which_container === 'only_icon'){
            // Find the <g> elements for icon, and monogram and set them to black
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#000000');
            });
            // Find the <g> elements for business name and slogan and set them to white
            const elementsToChange2 = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
            elementsToChange2.forEach(element => {
              element.setAttribute('fill', '#FFFFFF');
            });
          }
          else{
            // Find the <g> elements for business name, slogan, icon, and monogram and set them to black
            const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"]');
            elementsToChange.forEach(element => {
              element.setAttribute('fill', '#000000');
            });
          }

          applyDefaultColors = false; // Don't apply default colors if container_num is 6
        }
      }

      // Apply default colors if the container doesn't exist or if container_num is not 6
      if (applyDefaultColors) {
        // Set business name, slogan, icon, monogram, and container to black if they exist
        const elementsToChange = svgDocument.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"], g[data-name="icon"], g[data-name="monogram"], g[data-name="container"]');
        elementsToChange.forEach(element => {
          element.setAttribute('fill', '#FFFFFF');
        });
      }

      // Serialize the modified SVG back to a string
      const serializer = new XMLSerializer();
      const modifiedSvgCode = serializer.serializeToString(svgDocument);

      // Save SVG code string
      this.files.high_res_white_transparent_bg_svgcode = modifiedSvgCode;

      // Encode the SVG code to Base64
      const base64Svg = btoa(encodeURIComponent(modifiedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
      }));

      // Save the base64 encoded SVG into files.high_res_color_logo_black_white_conditional_base64
      this.files.high_res_white_transparent_bg_base64 = `data:image/svg+xml;base64,${base64Svg}`;
    },
    setFaviconOriginalColor() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <g> element with data-name="icon" or "monogram"
      const iconElement = svgDocument.querySelector('[data-name="icon"], [data-name="monogram"]');

      if (iconElement) {
        // Remove the transform attribute from the <g> element
        iconElement.removeAttribute('transform');

        // Create a new SVG document to store only the filtered elements
        const newSvgDocument = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newSvgDocument.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        newSvgDocument.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        newSvgDocument.setAttribute("width", "400");
        newSvgDocument.setAttribute("height", "400");
        newSvgDocument.setAttribute("viewBox", "0 0 400 400");

        // Check if there is a <defs> element in the original SVG
        const defsElement = svgDocument.querySelector('defs');
        if (defsElement) {
          // Clone the <defs> element and append it to the new SVG document
          newSvgDocument.appendChild(defsElement.cloneNode(true));
        }

        // Append the modified <g> element to the new SVG document
        newSvgDocument.appendChild(iconElement.cloneNode(true));

        // Serialize the new SVG document back to a string
        const serializer = new XMLSerializer();
        const filteredSvgCode = serializer.serializeToString(newSvgDocument);

        // Save the filtered SVG code string
        this.files.favicon_original_color_svgcode = filteredSvgCode;

        // Encode the SVG code to Base64
        const base64Svg = btoa(encodeURIComponent(filteredSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          return String.fromCharCode('0x' + p1);
        }));

        // Save the base64 encoded SVG into files.favicon_original_color_base64
        this.files.favicon_original_color_base64 = `data:image/svg+xml;base64,${base64Svg}`;

        // Load the SVG into the offscreen container
        const container = document.getElementById('svgContainer-edit');
        container.innerHTML = this.files.favicon_original_color_svgcode;

        // Access the <svg> element inside the container
        const svgElement = container.querySelector('svg');

        // Access the <g> element with data-name="icon" or "monogram"
        const finalIconElement = svgElement.querySelector('g[data-name="icon"], g[data-name="monogram"]');

        if (finalIconElement) {
          // Get the bounding box of the <g> element
          const boundingBox = finalIconElement.getBBox();
          const iconWidth = boundingBox.width;
          const iconHeight = boundingBox.height;

          // Calculate the scale factor to make the icon fit within 90% of the viewBox
          const scaleFactor = Math.min(0.9 * 400 / iconWidth, 0.9 * 400 / iconHeight);

          // Calculate translation to center the icon within the viewBox
          const translateX = (400 - iconWidth * scaleFactor) / 2 - boundingBox.x * scaleFactor;
          const translateY = (400 - iconHeight * scaleFactor) / 2 - boundingBox.y * scaleFactor;

          // Apply the transformation to the <g> element to scale and center it
          finalIconElement.setAttribute('transform', `translate(${translateX}, ${translateY}) scale(${scaleFactor})`);

          // Serialize the modified SVG back to a string
          const updatedSvgCode = serializer.serializeToString(svgElement);

          // Update the SVG and Base64 with the transformed icon
          this.files.favicon_original_color_svgcode = updatedSvgCode;
          this.files.favicon_original_color_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode('0x' + p1);
          }))}`;

          // Create black favicon
          // Change the color of the icon to black
          finalIconElement.querySelectorAll('path').forEach(path => {
            path.setAttribute('fill', '#000000'); // Set fill to black
          });

          // Serialize the modified SVG back to a string
          const updatedSvgCodeBlack = serializer.serializeToString(svgElement);

          // Save the black version of the SVG and its Base64
          this.files.favicon_black_svgcode = updatedSvgCodeBlack;
          this.files.favicon_black_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCodeBlack).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode('0x' + p1);
          }))}`;

          // Create white favicon
          // Change the color of the icon to white
          finalIconElement.querySelectorAll('path').forEach(path => {
            path.setAttribute('fill', '#FFFFFF'); // Set fill to white
          });

          // Serialize the modified SVG back to a string
          const updatedSvgCodeWhite = serializer.serializeToString(svgElement);

          // Save the white version of the SVG and its Base64
          this.files.favicon_white_svgcode = updatedSvgCodeWhite;
          this.files.favicon_white_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCodeWhite).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode('0x' + p1);
          }))}`;

          // Log the final width and height to the console
          // console.log(`Final Icon/Monogram Width: ${iconWidth}, Final Icon/Monogram Height: ${iconHeight}`);
        } else {
          console.error("Final <g> element with data-name='icon' or 'monogram' not found.");
        }

      } else {
        console.error("Icon or Monogram not found in SVG.");
      }
    },
    setIconOnly() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Find the <g> element with data-name="icon" or "monogram"
      const iconElement = svgDocument.querySelector('[data-name="icon"], [data-name="monogram"]');

      if (iconElement) {
        // Remove the transform attribute from the <g> element
        iconElement.removeAttribute('transform');

        // Create a new SVG document to store only the filtered elements
        const newSvgDocument = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newSvgDocument.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        newSvgDocument.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        newSvgDocument.setAttribute("width", "400");
        newSvgDocument.setAttribute("height", "400");
        newSvgDocument.setAttribute("viewBox", "0 0 400 400");

        // Check if there is a <defs> element in the original SVG
        const defsElement = svgDocument.querySelector('defs');
        if (defsElement) {
          // Clone the <defs> element and append it to the new SVG document
          newSvgDocument.appendChild(defsElement.cloneNode(true));
        }

        // Append the modified <g> element to the new SVG document
        newSvgDocument.appendChild(iconElement.cloneNode(true));

        // Serialize the new SVG document back to a string
        const serializer = new XMLSerializer();
        const filteredSvgCode = serializer.serializeToString(newSvgDocument);

        // Save the filtered SVG code string
        this.files.icononly_original_color_svgcode = filteredSvgCode;

        // Encode the SVG code to Base64
        const base64Svg = btoa(encodeURIComponent(filteredSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          return String.fromCharCode('0x' + p1);
        }));

        // Save the base64 encoded SVG into files.icononly_original_color_base64
        this.files.icononly_original_color_base64 = `data:image/svg+xml;base64,${base64Svg}`;

        // Load the SVG into the offscreen container
        const container = document.getElementById('svgContainer-edit');
        container.innerHTML = this.files.icononly_original_color_svgcode;

        // Access the <svg> element inside the container
        const svgElement = container.querySelector('svg');

        // Access the <g> element with data-name="icon" or "monogram"
        const finalIconElement = svgElement.querySelector('g[data-name="icon"], g[data-name="monogram"]');

        if (finalIconElement) {
          // Get the bounding box of the <g> element
          const boundingBox = finalIconElement.getBBox();
          const iconWidth = boundingBox.width;
          const iconHeight = boundingBox.height;

          // Calculate the scale factor to make the icon fit within 80% of the viewBox
          const scaleFactor = Math.min(0.9 * 400 / iconWidth, 0.8 * 400 / iconHeight);

          // Calculate translation to center the icon within the viewBox
          const translateX = (400 - iconWidth * scaleFactor) / 2 - boundingBox.x * scaleFactor;
          const translateY = (400 - iconHeight * scaleFactor) / 2 - boundingBox.y * scaleFactor;

          // Apply the transformation to the <g> element to scale and center it
          finalIconElement.setAttribute('transform', `translate(${translateX}, ${translateY}) scale(${scaleFactor})`);

          // Serialize the modified SVG back to a string
          const updatedSvgCode = serializer.serializeToString(svgElement);

          // Update the SVG and Base64 with the transformed icon
          this.files.icononly_original_color_svgcode = updatedSvgCode;
          this.files.icononly_original_color_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode('0x' + p1);
          }))}`;

          // Create black favicon
          // Change the color of the icon to black
          finalIconElement.querySelectorAll('path').forEach(path => {
            path.setAttribute('fill', '#000000'); // Set fill to black
          });

          // Serialize the modified SVG back to a string
          const updatedSvgCodeBlack = serializer.serializeToString(svgElement);

          // Save the black version of the SVG and its Base64
          this.files.icononly_black_svgcode = updatedSvgCodeBlack;
          this.files.icononly_black_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCodeBlack).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode('0x' + p1);
          }))}`;

          // Create white favicon
          // Change the color of the icon to white
          finalIconElement.querySelectorAll('path').forEach(path => {
            path.setAttribute('fill', '#FFFFFF'); // Set fill to white
          });

          // Serialize the modified SVG back to a string
          const updatedSvgCodeWhite = serializer.serializeToString(svgElement);

          // Save the white version of the SVG and its Base64
          this.files.icononly_white_svgcode = updatedSvgCodeWhite;
          this.files.icononly_white_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCodeWhite).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode('0x' + p1);
          }))}`;

          // Log the final width and height to the console
          // console.log(`Final Icon/Monogram Width: ${iconWidth}, Final Icon/Monogram Height: ${iconHeight}`);
        } else {
          console.error("Final <g> element with data-name='icon' or 'monogram' not found.");
        }

      } else {
        console.error("Icon or Monogram not found in SVG.");
      }
    },
    setBusinessNameAndSloganOnly() {
      // Get the SVG code string from this.logo.svg
      let svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Remove the container and icon elements
      const backgroundElement = svgDocument.querySelector('[data-name="background"]');
      const containerElement = svgDocument.querySelector('[data-name="container"]');
      const iconElement = svgDocument.querySelector('[data-name="icon"]');
      const monogramElement = svgDocument.querySelector('[data-name="monogram"]');
      if (backgroundElement) {
        backgroundElement.remove();
      }
      if (containerElement) {
        containerElement.remove();
      }
      if (iconElement) {
        iconElement.remove();
      }
      if (monogramElement) {
        monogramElement.remove();
      }

      // Find the <g> elements with data-name="business_name" and "slogan"
      const businessNameElement = svgDocument.querySelector('[data-name="business_name"]');
      const sloganElement = svgDocument.querySelector('[data-name="slogan"]');

      if (businessNameElement || sloganElement) {
        // Create a new <g> element to group business_name and slogan
        const combinedGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
        combinedGroup.setAttribute("data-name", "business_name_slogan_group");

        if (businessNameElement) {
          combinedGroup.appendChild(businessNameElement.cloneNode(true));
          businessNameElement.remove();
        }

        if (sloganElement) {
          combinedGroup.appendChild(sloganElement.cloneNode(true));
          sloganElement.remove();
        }

        // Append the new group to the SVG document
        svgDocument.documentElement.appendChild(combinedGroup);

        // Load the SVG into the offscreen container to get the bounding box
        const container = document.getElementById('svgContainer-edit');
        container.innerHTML = new XMLSerializer().serializeToString(svgDocument);

        // Access the <svg> element inside the container
        const svgElement = container.querySelector('svg');

        // Access the new <g> element containing business_name and slogan
        const finalGroupElement = svgElement.querySelector('g[data-name="business_name_slogan_group"]');

        if (finalGroupElement) {
          // Get the bounding box of the combined group
          const boundingBox = finalGroupElement.getBBox();
          const combinedWidth = boundingBox.width;
          const combinedHeight = boundingBox.height;

          // Calculate the translation needed to center the group within the viewBox
          const translateX = (400 - combinedWidth) / 2 - boundingBox.x;
          const translateY = (400 - combinedHeight) / 2 - boundingBox.y;

          // Apply the transformation to the <g> element to center it
          const existingTransform = finalGroupElement.getAttribute('transform') || '';
          finalGroupElement.setAttribute('transform', `${existingTransform} translate(${translateX}, ${translateY})`);

          // Log the combined width and height to the console
          // console.log(`Combined Business Name and Slogan Width: ${combinedWidth}, Combined Height: ${combinedHeight}`);
        }

        // Serialize the modified SVG back to a string
        const serializer = new XMLSerializer();
        const updatedSvgCode = serializer.serializeToString(svgElement);

        // Update the SVG and Base64 with the transformed icon
        this.files.only_business_slogan_svgcode = updatedSvgCode;
        this.files.only_business_slogan_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          return String.fromCharCode('0x' + p1);
        }))}`;

        // Create black favicon
        // Set business name, slogan to black if they exist
        const elementsToChange = svgElement.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
        elementsToChange.forEach(element => {
          element.setAttribute('fill', '#000000');
        });

        // Serialize the modified SVG back to a string
        const updatedSvgCodeBlack = serializer.serializeToString(svgElement);

        // Save the black version of the SVG and its Base64
        this.files.only_business_slogan_black_svgcode = updatedSvgCodeBlack;
        this.files.only_business_slogan_black_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCodeBlack).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          return String.fromCharCode('0x' + p1);
        }))}`;

        // Create white favicon
        // Set business name, white to black if they exist
        const elementsToChange2 = svgElement.querySelectorAll('g[data-name="business_name"], g[data-name="slogan"]');
        elementsToChange2.forEach(element => {
          element.setAttribute('fill', '#FFFFFF');
        });

        // Serialize the modified SVG back to a string
        const updatedSvgCodeWhite = serializer.serializeToString(svgElement);

        // Save the white version of the SVG and its Base64
        this.files.only_business_slogan_white_svgcode = updatedSvgCodeWhite;
        this.files.only_business_slogan_white_base64 = `data:image/svg+xml;base64,${btoa(encodeURIComponent(updatedSvgCodeWhite).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          return String.fromCharCode('0x' + p1);
        }))}`;
      } else {
        console.error("Business Name or Slogan not found in SVG.");
      }
    }
  },
  mounted() {
    this.logo_unique_id = this.$route.params.logo_unique_id;
    this.$emit('updatepath');
    axios.post('/dashboard/get-logo-data.php', {
      unique_id: this.logo_unique_id
    })
    .then(response => {
      if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
        this.retry_axios = this.retry_axios+1;
        this.propsdata[0].saving_logo = false;
        this.choose_logo(object);
      }
      else if(response.data === 'logo not found'){
        this.$router.push('/dashboard/get-logo-files/'); //redirect to select brand
      }
      else{
        this.retry_axios = 1;
        this.logo = response.data;
        this.setHighResColorLogo();
        this.setHighResBlackAndWhite();
        this.setHighResWhiteAndBlack();
        this.setHighResColorLogoTransparentBackground();
        this.setHighResBlackTransparentBackground();
        this.setHighResWhiteTransparentBackground();
        this.setFaviconOriginalColor();
        this.setIconOnly();
        this.setBusinessNameAndSloganOnly();
        this.loading = false;
      }
    })
    .catch(function (error) {
      console.log(error);
      this.retry_axios = 1;
    });
  },
  // do not forget this section
directives: {
ClickOutside
}
};
</script>



// WEBPACK FOOTER //
// src/logo-files.vue